import Vue from 'vue'
import Vuex from 'vuex'

import auth from './modules/auth'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  getters: {
    kakaoData: (state) => state.auth.kakaoData,
    loginDialog: (state) => state.auth.loginDialog,
    loginRequestCount: (state) => state.auth.loginRequestCount
  },
  modules: {
    auth
  }
})
